import { render, staticRenderFns } from "./DashboardCM.vue?vue&type=template&id=44a87af3&scoped=true&"
import script from "./DashboardCM.vue?vue&type=script&lang=js&"
export * from "./DashboardCM.vue?vue&type=script&lang=js&"
import style0 from "./DashboardCM.vue?vue&type=style&index=0&id=44a87af3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a87af3",
  null
  
)

export default component.exports